import { useEffect, useState } from 'react';
import { requestJson } from '../services/api';

export default function useSessionValidation(userId, onInvalid) {
  const [error, setError] = useState('');
  useEffect(() => {
    let stopped = false;
    let timer;
    const controller = new AbortController();
    const check = async () => {
      const token = localStorage.getItem('session_token');
      if (!token || !userId) { onInvalid(); return; }
      try {
        const result = await requestJson('validate_token.php', {
          method: 'POST', signal: controller.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: userId, session_token: token })
        });
        if (stopped) return;
        if (result.status === 'invalid') { onInvalid(); return; }
        if (result.status !== 'valid') throw new Error('Session check unavailable');
        setError('');
      } catch (err) {
        if (stopped) return;
        setError('Connection interrupted. Rechecking your session automatically.');
      }
      if (!stopped) timer = setTimeout(check, 30000);
    };
    check();
    return () => { stopped = true; clearTimeout(timer); controller.abort(); };
  }, [userId, onInvalid]);
  return error;
}
